(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-share-buttons"] && !Shopify.designMode) return;
  try {
    if (!window.productShareButtonsInitialized) {
    window.productShareButtonsInitialized = true;

    document.addEventListener('click', async (event) => {
      const button = event.target.closest('[data-instagram-share-button]');

      if (!(button instanceof HTMLButtonElement)) return;

      const shareUrl = button.dataset.shareUrl;
      const shareTitle = button.dataset.shareTitle;
      const isDesktopViewport = window.matchMedia('(min-width: 750px)').matches;

      if (!shareUrl) return;

      try {
        if (!isDesktopViewport && navigator.share) {
          await navigator.share({
            title: shareTitle,
            text: shareTitle,
            url: shareUrl,
          });
          return;
        }

        window.open('https://www.instagram.com/', '_blank', 'noopener,noreferrer');
      } catch (error) {
        if (error?.name === 'AbortError') return;
        console.error(error);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
